export default {
  title: 'Workspace is not currently available',
  text: 'Please Contact the Administrator',
  button: 'Go back',
};
